import React from "react";
import {Button, Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {languageSelector} from "../../../state/app/appSelectors";
import {nodeCodeSelector} from "../../../state/node/nodeSelectors";

const CategoriesButton = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const language = useSelector(languageSelector);
  const nodeCode = useSelector(nodeCodeSelector);
  return (
    nodeCode && (
      <Grid>
        <Button
          onClick={() => navigate(`/${language}/${(nodeCode || "").toLowerCase()}/categories`)}
          aria-label={t("components.header.actions.categories.label", "Topics")}
          sx={{
            color: theme => theme.palette.primary.contrastText,
            whiteSpace: "nowrap"
          }}
        >
          {t("components.header.actions.categories.label", "Topics")}
        </Button>
      </Grid>
    )
  );
};

export default CategoriesButton;
